
export enum PlatformBusClass {
  City= 'City',
  Intercity= 'Intercity',
  Touristic= 'Touristic',
  SchoolBus= 'SchoolBus',

}